import type {TbiScheme} from '../../server/types/PymentMethodInterface'

export function isTbiCheckoutUrl(value: unknown): value is string {
    if (typeof value !== 'string') return false
    try {
        const url = new URL(value)
        return url.protocol === 'https:' && !url.username && !url.password && !url.port &&
            ['beta.tbibank.support', 'bnkl.tbibank.bg', 'bankly-uat.tbibank.bg'].includes(url.hostname)
    } catch { return false }
}

export function chooseTbiScheme(schemes: TbiScheme[], selected?: number): number | undefined {
    return schemes.find(s => s.id === selected)?.id ?? schemes.find(s => s.period === 12)?.id ?? schemes[0]?.id
}
